export const isEmbedded = window.frameElement !== null;
